// @flow
import React from 'react';
import {useIntl, defineMessages, FormattedMessage} from 'react-intl';
import type {SearchableSelectResultProps} from 'sail/Search';
import {SearchableSelect, SearchableSelectEmpty, useSearch} from 'sail/Search';
import {useApiExplorer} from './ApiExplorerProvider';

type ResourceSelectorProps = {|
  resource_names: Array<string>,
  queryResources: any,
  getSearchableText: any,
|};

const messages = defineMessages({
  search: {
    id: 'docsApp.actionSelector.search',
    description: 'Placeholder text for resource selector',
    defaultMessage: 'Select a resource',
  },
  noResults: {
    id: 'docsApp.actionSelector.noResults',
    description: 'No results found',
    defaultMessage: 'No results found',
  },
});

const renderItem = (props: SearchableSelectResultProps<string>) => {
  return props.entry;
};

const renderEmpty = () => (
  <SearchableSelectEmpty>
    <FormattedMessage {...messages.noResults} />
  </SearchableSelectEmpty>
);

export const ResourceSelector = ({
  resource_names,
  queryResources,
  getSearchableText,
}: ResourceSelectorProps) => {
  // Resource Selection
  const resourceSearchProps = useSearch(queryResources);
  const intl = useIntl();
  const {
    state: {resource},
    setResource,
  } = useApiExplorer();

  return (
    <SearchableSelect
      {...resourceSearchProps}
      inputPlaceholder={intl.formatMessage(messages.search)}
      getSearchableText={getSearchableText}
      onChange={(value) => setResource(value || '')}
      value={resource}
      width={300}
      renderItem={renderItem}
      renderEmpty={renderEmpty}
      getButtonLabel={(entry: string) => entry}
      size="jumbo"
    />
  );
};
